export default __webpack_public_path__ + "static/media/251.893eaeca.png";